//
//  :react & redux:
import React from 'react'
import { Content } from '../components/Content'

//
//  :components:

//
//  :component:
export const Ended = props => {
  return (
    <>
      <Content>
        <div className="eky-diwali-coming-soon-container w-screen h-screen relative flex flex-col">
          <img
            className="absolute bottom-0 right-0 hidden md:flex"
            src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-coming-soon-mandala-004.png"
            alt=""
          />
          <img
            className="absolute flex md:hidden bottom-[3rem] right-0 w-full"
            src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-coming-soon-mobile-mandala-001.png"
            alt=""
          />
          <img
            className="absolute top-0 left-0 max-w-[17rem] md:max-w-[20rem] md:max-w-none"
            src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-title-002.svg"
            alt=""
          />
          <img
            className="absolute right-0 bottom-[5rem] md:right-[10%] md:bottom-[2%] z-[2] max-h-[25rem] md:max-h-none"
            src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-coming-soon-bottle-001.png"
            alt=""
          />

          <div className="w-full h-[10rem] bg-[#7B4797] absolute bottom-[7rem] md:bottom-[110px] uppercase flex items-center border-y-4 border-[#E95E0F]">
            <p className="text-white text-[38px] md:text-[64px] ml-0 md:ml-[10%] text-center w-[10rem] md:w-auto leading-none">
              EXPERIENCE HAS NOW ENDED
            </p>
          </div>

          <div className="w-full flex justify-center items-center uppercase absolute bottom-[4rem] md:bottom-2">
            <p className="text-white text-[8px] md:text-[12px]">
              DRINK DEWAR’S RESPONSIBLY. DEWAR’S, ITS TRADE DRESS AND THE CELTIC LOGO ARE TRADEMARKS.
            </p>
          </div>
        </div>
      </Content>
    </>
  )
}
